import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const Body = styled.div`
  ${tw`w-full overflow-hidden mt-abs1`};
  max-height: ${(props) => (props.show ? 'fit-content' : '0')};
  transition: max-height 300ms ease-in-out;
`;

export default Body;
